import { useForm } from "react-hook-form";

import { isEmpty } from "lodash";
import Tabs from "../../Components/CommonCommponents/Tabs/Tabs";
import RequiredFieldProfile from "./RequiredFeildProfile";
import RequiredFormExperience from "./RequiredFormExperience";
import RequiredFormProjects from "./RequiredFormProjects";

const RequiredFieldForm = ({
  fields,
  candidate_id,
  setEnable,
  setRequiredFields,
  userId
}) => {
  const {
    clearErrors,
    register,
    handleSubmit,
    setValue,
    getValues,
    control,
    setError,
    reset,
    watch,
    formState: { errors },
  } = useForm({
    mode: "all",
    defaultValues: {},
  });
  const CANDIDATE_DETAILS_TAB_KEYS = {
    JOBS: "jobs",
    RESUME: "resume",
    PROFILE: "profile",
    DOCUMENTS: "documents",
    EXPERIENCE: "experience",
  };
  const tabsArray = [
    {
      key: CANDIDATE_DETAILS_TAB_KEYS.PROFILE,
      tabName: "Profile",
      children: (
        <RequiredFieldProfile
          nCandidateId={candidate_id}
          fields={fields}
          setEnable={setEnable}
          userId={userId}
          setRequiredFields={setRequiredFields}
          // onClose={() => closeCandidateForm()}
        />
      ),
      enable:
        fields?.filter((f) => f !== "experiences" && f !== "projects").length >
        0,
    },
    {
      key: CANDIDATE_DETAILS_TAB_KEYS.EXPERIENCE,
      tabName: "Experience",
      children: (
        <RequiredFormExperience
          experiences={[]}
          candidateId={candidate_id}
          setEnable={setEnable}
          setRequiredFields={setRequiredFields}
        />
      ),
      enable: fields?.includes("experiences"),
    },
    {
      key: "projects",
      tabName: "Projects",
      children: (
        <RequiredFormProjects
          experiences={[]}
          candidateId={candidate_id}
          setEnable={setEnable}
          setRequiredFields={setRequiredFields}
        />
      ),
      enable: fields?.includes("projects"),
    },
  ].filter((item) => !isEmpty(item) && item.enable === true);

  const tabsItems = tabsArray.map((item) => {
    return {
      key: item.key,
      label: item.tabName,
      children: item.children,
    };
  });

  return (
    <div className="flex items-center flex-col justify-center">
      <Tabs
        items={tabsItems}
        className="w-full"
        // activeKey={infoTabName}
        defaultActiveKey={CANDIDATE_DETAILS_TAB_KEYS.PROFILE}
      />
    </div>
  );
};

export default RequiredFieldForm;
